"use strict";
/*
 * Created on 2019-03-28
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../core/utils");

var SelloutReleaseItemKey_1 = require("../../model/sellout/SelloutReleaseItemKey");

var SelloutReleaseItemKeyConverter_1 = require("./SelloutReleaseItemKeyConverter");
/**
 * @author Radek Beran
 */


var SelloutReleaseItemKeyConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemKe) {
  _inherits(SelloutReleaseItemKeyConverterImpl, _SelloutReleaseItemKe);

  function SelloutReleaseItemKeyConverterImpl() {
    _classCallCheck(this, SelloutReleaseItemKeyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemKeyConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutReleaseItemKeyConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleaseItemKey_1.SelloutReleaseItemKey(SelloutReleaseItemKey_1.SelloutReleaseItemKey.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), SelloutReleaseItemKey_1.SelloutReleaseItemKey.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), utils_1.Utils.isValueMissing(source.siteId) ? null : SelloutReleaseItemKey_1.SelloutReleaseItemKey.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: source.siteId !== null ? conversions.toDocumentReferenceId(source.siteId) : null
      };
    }
  }]);

  return SelloutReleaseItemKeyConverterImpl;
}(SelloutReleaseItemKeyConverter_1.SelloutReleaseItemKeyConverter);

exports.SelloutReleaseItemKeyConverterImpl = SelloutReleaseItemKeyConverterImpl;